import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import Fade from 'react-reveal/Fade';

function toEmbedUrl(url) {
  if (!url) return null;
  const match = url.match(/(?:v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
}

function Banner() {
  const [embedUrl, setEmbedUrl] = useState('https://www.youtube.com/embed/XZbWotQd_Lk');

  useEffect(() => {
    fetch('/api/settings')
      .then(r => r.json())
      .then(data => {
        const url = toEmbedUrl(data.featured_youtube_url);
        if (url) setEmbedUrl(url);
      })
      .catch(() => {});
  }, []);

  return (
    <Box sx={{ backgroundColor: '#0d0d0d', py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <Fade bottom>
          <Box textAlign="center" mb={6}>
            <Typography
              variant="overline"
              sx={{ color: '#FFA13C', letterSpacing: '0.2em', fontWeight: 600 }}
            >
              Featured Video
            </Typography>
            <Typography
              variant="h3"
              sx={{
                color: '#f0f0f0',
                fontWeight: 700,
                mt: 1,
                fontSize: { xs: '1.8rem', md: '2.5rem' },
              }}
            >
              See The Craftsmanship
            </Typography>
          </Box>
        </Fade>

        <Fade bottom delay={100}>
          {/* 16:9 video container */}
          <Box
            sx={{
              position: 'relative',
              paddingTop: '56.25%',
              borderRadius: 2,
              overflow: 'hidden',
              border: '1px solid #222',
              boxShadow: '0 24px 80px rgba(0,0,0,0.6)',
            }}
          >
            <iframe
              src={embedUrl}
              title="Emerich Custom Build showcase"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0, left: 0,
                width: '100%', height: '100%',
              }}
            />
          </Box>
        </Fade>

        <Fade bottom delay={200}>
          <Box textAlign="center" mt={6}>
            <Button
              component={Link}
              to="/portfolio"
              variant="outlined"
              size="large"
              sx={{
                borderColor: '#FFA13C',
                color: '#FFA13C',
                fontWeight: 600,
                px: 5,
                py: 1.5,
                borderRadius: 0,
                letterSpacing: '0.08em',
                '&:hover': { backgroundColor: 'rgba(255,161,60,0.08)', borderColor: '#FFA13C' },
              }}
            >
              View All Projects
            </Button>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
}

export default Banner;
